export const logSortByLocalStorageKey = 'logsSortBy';
export const LOG_REFETCH_INTERVAL = 10000;
